/* istanbul ignore file */

import {
    AuthenticationRequest,
    AuthenticationResponse,
    AuthenticatorSignAssertion,
    BrowserBindingAuthenticator,
    BrowserBindingKey,
    CorsKey,
    Keychain,
    KeychainReference,
    PasswordAuthenticator,
    PasswordKey,
    RegistrationRequest,
    RegistrationResponse
} from '@velorum/browser-authenticator';

import { Injectable } from '@angular/core';

declare let auth;

@Injectable({ providedIn: 'root' })
export class ApVelorumInterface {
    newKeychain(): Keychain {
        return new auth.Keychain();
    }

    newPasswordKey(): PasswordKey {
        return new auth.PasswordKey();
    }

    newPasswordAuthenticator(pk: PasswordKey | CorsKey): PasswordAuthenticator {
        return new auth.PasswordAuthenticator(pk);
    }

    newBrowserBindingKey(): BrowserBindingKey {
        return new auth.BrowserBindingKey();
    }

    newBrowserBindingAuthenticator(bbk: BrowserBindingKey | CorsKey): BrowserBindingAuthenticator {
        return new auth.BrowserBindingAuthenticator(bbk);
    }

    generateRegistrationResponse(registrationRequest: RegistrationRequest, assertions: AuthenticatorSignAssertion[]): RegistrationResponse {
        return auth.FidoUtil.generateRegistrationResponse(registrationRequest, assertions);
    }

    generateAuthenticationResponse(
        authenticationRequest: AuthenticationRequest,
        assertions: AuthenticatorSignAssertion[]
    ): AuthenticationResponse {
        return auth.FidoUtil.generateAuthenticationResponse(authenticationRequest, assertions);
    }

    getFingerprint(): Uint8Array {
        return auth.Keychain.getFingerprint();
    }

    hasCorsClient(): boolean {
        return auth.CorsKeychain.getCorsClient() != null;
    }

    isCorsReady(): boolean {
        return auth.CorsKeychain.isReady();
    }

    async initCorsKeychain(targetOrigin: string, targetPath: string, timeout: number): Promise<void> {
        return auth.CorsKeychain.init(targetOrigin, targetPath, timeout);
    }

    async listCorsKeychains(): Promise<Array<KeychainReference>> {
        return auth.CorsKeychain.listKeychains();
    }

    async listKeychains(): Promise<Array<KeychainReference>> {
        return auth.Keychain.listKeychains();
    }

    async getCorsKeychain(keychainId: string): Promise<Keychain> {
        return auth.CorsKeychain.getKeychain(keychainId);
    }

    async getKeychain(keychainId: string): Promise<Keychain> {
        return auth.Keychain.getKeychain(keychainId);
    }

    async storeKeychain(keychain: Keychain): Promise<Keychain> {
        return auth.Keychain.storeKeychain(keychain);
    }

    async deleteKeychain(keychainId: string): Promise<void> {
        return auth.Keychain.deleteKeychain(keychainId);
    }
}
